// src/components/servicePartnerFinder/utils.ts

export const toNumberOrNull = (
    value: number | string | null | undefined
): number | null => {
    if (value === null || value === undefined) return null
    const n = Number(value)
    return Number.isNaN(n) ? null : n
}
